import axios from './configAxiosOrganizations';

export const putWorkerOrganization = async (userId, requestData) => {
	return axios.put(`/worker/${userId}/update/`, requestData);
};
